import { config } from '@/config'
import { Toast } from 'vant'
import getNativeInstance from '@/utils/JSBridge'
import dayjs from 'dayjs'

/**
 * 动态设置浏览器标题
 * @param title
 */
export const setDocumentTitle = (title?: string) => {
	document.title = title || config.title
}

/**
 * 处理await成功失败信息
 * 参考：https://juejin.cn/post/6844903767129718791
 * @param {*} promise
 */

export function awaitWrap<T, U = any>(promise: Promise<T>): Promise<[U | null, T | null]> {
	return promise.then<[null, T]>((data: T) => [null, data]).catch<[U, null]>((err) => [err, null])
}

/*
 * 第一种方法：
 * @param paramName
 * 用来获取url中的某个参数
 */
export const getQueryParamByKey = (paramName: string) => {
	let url = document.location.toString()
	// 如果url中有特殊字符则需要进行一下解码
	url = decodeURI(url)
	const arrObj = url.split('?')
	if (arrObj.length > 1) {
		const arrPara = arrObj[1].split('&')
		let arr
		for (let i = 0; i < arrPara.length; i++) {
			arr = arrPara[i].split('=')
			if (arr != null && arr[0] == paramName) {
				return decodeURIComponent(arr[1])
			}
		}
		return ''
	} else {
		return ''
	}
}
/*
 * 用来获取url中的所有参数
 * let url = 'http://192.168.1.122:9020/?appId=wxf4b72971eacba4d6&loginScene=1#/'
 */
export const getQueryParams = <T>(url = document.location.toString()) => {
	// let url =
	// 如果url中有特殊字符则需要进行一下解码
	url = decodeURI(url)
	const arr1 = url.split('?')
	const obj = {} as T
	if (arr1.length > 1) {
		const index = arr1[1].indexOf('#')
		arr1[1] = index == -1 ? arr1[1] : arr1[1].slice(0, index)
		const arr2 = arr1[1].split('&')
		for (let i = 0; i < arr2.length; i++) {
			const curArr: string[] = arr2[i].split('=')
			obj[curArr[0]] = decodeURIComponent(curArr[1])
		}
	}
	return obj
}

/**
 * 判断是安卓还是iOS
 */
export const phoneModel = () => {
	const u = navigator.userAgent
	const app = navigator.appVersion
	const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //android终端或者uc浏览器
	const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
	if (isAndroid) return 'android'
	if (isiOS) return 'ios'
}
/**
 * 判断是否是微信浏览器
 */
export const isWeChat = () => {
	//window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
	const ua = navigator.userAgent
	//通过正则表达式匹配ua中是否含有MicroMessenger字符串
	return !!ua.match(/MicroMessenger/i)
}

// 获取 # 前面的数据
export const getQueryString = (name) => {
	const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i')
	const search = window.location.search
	const r = search.substr(1).match(reg)
	if (r != null) return unescape(r[2])
	return null
}

// 判断是否是生产环境
export const isProduction = () => {
	return process.env.NODE_ENV === 'production'
}

// 使用正则表达式将数字按千位添加逗号
export const formatCurrency = (number) => {
	return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
}

// app 打开新的webview
export const openWebview = ({ url, title }) => {
	if (window.UniAppJSBridge) {
		getNativeInstance().customInvoke({
			action: 'openWebview',
			data: {
				url: url,
				title: title
			}
		})
	}
}

// 判断日期是不是今天
export const isToday = (date) => {
	const today = dayjs().startOf('day') // 今天的开始时间
	return dayjs(date).startOf('day').isSame(today)
}
// 判断日期是不是昨天
export const isYesterday = (date) => {
	const today = dayjs().startOf('day') // 今天的开始时间
	const yesterday = today.subtract(1, 'day') // 昨天的开始时间
	return dayjs(date).startOf('day').isSame(yesterday)
}
